<template>
    <div class="activityAnalysis spackage padding-20 bgc box-shadow">
         <div class="head">
            <div class="flex right">
                <el-date-picker v-model="times" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy-MM-dd" value-format="yyyy-MM-dd"  class="item" style="width: 250px"></el-date-picker>
                <el-input v-model="apidata.assname" placeholder="请输入社群名称" class="input item"></el-input>
                <el-button type="primary" @click="search" class="item">搜索</el-button>
                <el-button class="item" @click="dc">导出</el-button>
            </div>
       </div>
       <el-table rel="singleTable" :data="tableInfo" @sort-change="sortChange">
            <el-table-column label="社群名称" property='assname' align="left">
            </el-table-column>

            <el-table-column label="活动名称" property='title' align="center">
            </el-table-column>
            <el-table-column label="活动时间" align="center" width="250">
                <template slot-scope="scope">
                    <p>开始时间：{{scope.row.begintime}}</p>
                    <p>结束时间：{{scope.row.endtime}}</p>
                </template>
            </el-table-column>
            <el-table-column label="参与人" sortable=‘custom’ property='joinusercount' align="center">
            </el-table-column>
            <el-table-column label="订单数" sortable=‘custom’ property='ordercount' align="center">
            </el-table-column>
              <el-table-column label="订单金额" sortable=‘custom’ property='totalincome' align="center">
            </el-table-column>
              <el-table-column label="活动转化率" property='activityconversion' align="center">
            </el-table-column>
        </el-table>

        <el-pagination background layout="prev, pager, next" :total="totalPage" @current-change="fPage"></el-pagination>

    </div>
</template>

<script>
import fecha from 'element-ui/src/utils/date'
import { downloadImage} from 'common/js/tools'
import { mapActions} from 'vuex' // 引入 vuex 组件
import $ from 'jquery'
import {getAgbEventInfodata, exportAgbEventInfodata} from 'api/cPurchaseApi'
import {dateFormat} from 'common/js/tools'
    export default {
        name: "ActivityAnalysis",
        data() {
           return {
              tableInfo: [],    //表单数据
              totalPage: 0,    //数据条数
              currentPage: 1, // 当前页
              times: '', // 搜索时间
              apidata: {
                title: '',
                beginTime: '',
                endTime: '',
                sortbyuser: '',
                sortbyorder: '',	
                sortbyordermoney: '',
                page: 1,       // 当前页数
                pageSize: 10    // 每页展示条数
              }
          }
        },
        mounted() {
            this.activelist(1)
        },
        methods: {
            sortChange(even) {
                let fliedName = even.prop,
                    sortingType = even.order,
                    apidata = this.apidata,
                    txt = ''
                    
                    switch (fliedName) {
                        case "joinusercount":
                            if (sortingType == "ascending") { 
                                txt = "joinusercount Asc"
                            } else if (sortingType == "descending") {
                                txt = "joinusercount DESC"
                            } else {
                                txt = ''
                            }
                            apidata.sortbyuser = txt
                            break
                        case "ordercount":
                            if (sortingType == "ascending") { 
                                txt = "ordercount ASC"
                            } else if (sortingType == "descending") {
                                txt = "ordercount DESC"
                            } else {
                                txt = ''
                            }
                            apidata.sortbyorder = txt
                            break
                        case "totalincome":
                            if (sortingType == "ascending") { 
                                txt = "totalincome ASC"
                            } else if (sortingType == "descending") {
                                txt = "totalincome DESC"
                            } else {
                                txt = ''
                            }
                             apidata.sortbyordermoney = txt
                            break
                    }
                this.activelist(apidata.page)
            },
            dc() {  // 导出
                let apidata = this.apidata,
                    api = {title: apidata.title, beginTime: apidata.beginTime, endTime: apidata.endTime}
                
                this.setLoading(true)
                exportAgbEventInfodata({
                    data: api,
                    success: data => {
                        this.setLoading(false)

                        this.exportTips = false
                        let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                        let fileName = '活动分析' + dateFormat(new Date()) + '.xls'
                        if (window.navigator.msSaveOrOpenBlob) {
                            navigator.msSaveBlob(blob, fileName)
                        } else {
                            var link = document.createElement('a')
                            link.href = window.URL.createObjectURL(blob)
                            link.download = fileName
                            link.click() // 释放内存
                            window.URL.revokeObjectURL(link.href)
                        }
                        this.$message.success('导出成功')

                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            activelist(page) {  // 活动列表
                this.apidata.page = page    // 取得页数
                this.setLoading(true)
                getAgbEventInfodata({
                    data: this.apidata,
                    success: data => {

                        this.tableInfo = data.data.content
                        this.totalPage = data.data.pageinfo.rowCount

                        console.log(data)
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }   
                })
            },
            search() {  // 搜索

                 if (this.times !== null && this.times[0]) {
                    this.apidata.beginTime = fecha.format(new Date(this.times[0]), 'yyyy-MM-dd')
                    this.apidata.endTime = fecha.format(new Date(this.times[1]), 'yyyy-MM-dd')
                } else {
                    this.apidata.beginTime = this.apidata.endTime  = ''
                }
                this.activelist(1) 
            },  
            fPage(){    // 分页
                let clickPage = $(".el-pagination .active").html()
                // console.log($('clickPage',$(".el-pagination .active").html()))
                this.activelist(clickPage)
            },
            ...mapActions([
                'setLoading'
            ])
        },
        filters: {},
        watch: {},
        computed: {},
        components: {}
    }
</script>

<style lang="scss" type="text/scss">
    .activityAnalysis {
        .one-title {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    }
    .sub-title {
         display: -webkit-box;
         display: -webkit-inline-box;
        -webkit-line-clamp: 2;
        line-clamp: 2;
        -webkit-box-orient: vertical;
        -moz-box-orient: vertical;
        -ms-box-orient: vertical;
        box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
    }
    .el-input__icon {
        line-height: normal;
    }
    .head {
        margin-bottom: 30px;
    }

    .position,
    .head,
    .flex {
        display: flex;
        flex-wrap: nowrap;
        -ms-flex-wrap: nowrap;
        justify-content: flex-end;
        width: 100%;
    }
        .flex.left {
            align-content: flex-start;
        }
        .flex.right {
            align-content: flex-end;
        }

        .head {
            .select {
                width: 108px;
            }
            .input {
                width: 220px;
            }
            .item {
                margin-left: 15px
            }
        }
        .el-pagination {
            margin-top: 20px;
            text-align: center;
        }

        .position {
            color: #439FFE;
            width: auto;
            float: right;

            p {
                margin: 0 5px;
                color: #439FFE;
                cursor: pointer;
            }
        }
    }
</style>
